import { ClassNameConsumer } from 'app/_utils/styled/ClassNameConsumer';

import styled, { css } from 'styled-components';

const PRIMARY_BLUE = 'rgba(24, 144, 255, 1)';

export const WorkspaceSelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-md);
  height: 16px;
`;

export const WorkspaceSwitcher = styled.div`
  padding: 8px 0;
`;

export const CurrentItemWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${PRIMARY_BLUE};
    span {
      color: ${PRIMARY_BLUE};
    }
  }
`;

export const WorkspaceInfo = styled.div`
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  align-items: center;
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const WorkspaceInfoWrap = styled(ClassNameConsumer)`
  fill: rgba(0, 0, 0, 0.45);
  color: rgba(0, 0, 0, 0.45);
  &:hover {
    fill: ${PRIMARY_BLUE};
    color: ${PRIMARY_BLUE};
    div {
      color: ${PRIMARY_BLUE};
      span {
        color: ${PRIMARY_BLUE};
      }
      svg {
        fill: ${PRIMARY_BLUE};
      }
    }
    span {
      color: ${PRIMARY_BLUE};
    }
  }
`;

export const WorkspaceName = styled.span`
  margin: 0 5px;
  color: inherit;
`;

const workspaceItemButtonBase = css`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  display: inline;
  outline: none;
  width: 100%;
  text-align: left;

  &:focus {
    outline: none;
  }
`;

export const CurrentWorkspaceItem = styled.button`
  ${workspaceItemButtonBase}
  color: ${PRIMARY_BLUE};
  cursor: pointer;
  transition: all 0.3s;
`;

export const InactiveWorkspaceItem = styled.button`
  ${workspaceItemButtonBase}
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
`;

export const ActiveSelectorItem = styled.button`
  ${workspaceItemButtonBase}
  color: inherit;
  cursor: pointer;
`;

export const ManageWorkspacesItem = styled.button`
  ${workspaceItemButtonBase}
  color: inherit;
  cursor: pointer;
`;

export const DropdownScrollableMenu = styled.div`
  max-height: 300px;
  overflow-y: auto;
  box-shadow:
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.08);
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.85);
`;
